const getDefaultPrivacy = (isReply?: boolean) => {
  return isReply ? 'FOLLOW_POST' : 'PUBLIC'
}

export default getDefaultPrivacy
